<template>
    <!-- 订单详情 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
    <div class="typeArea">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Order' }">我的订单</el-breadcrumb-item>
            <el-breadcrumb-item class="bread">订单详情</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 订单详情内容 -->
        <div class="detail-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="订单详情" name="first">
                    <OrderDetails />
                </el-tab-pane>
                <!-- <el-tab-pane label="订单留言" name="second">
                    <template #label>
                        <el-badge is-dot :hidden="hiddenBadge">
                            <span>订单留言</span>
                        </el-badge>
                    </template>
                    <LeaveWord />
                </el-tab-pane> -->
                <!-- <el-tab-pane label="账单明细" name="third">
                    <BillDetails :bill_change="bill_change" />
                </el-tab-pane> -->
            </el-tabs>

        </div>
    </div>
    <Bottom />

    </div>
</template>
    
<script>
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
import OrderDetails from "./OrderDetailsPage.vue";
// import LeaveWord from "./LeaveWordPage.vue";
// import LeaveWord from "./liuyanban.vue";
import { shipOrderDetail } from "@/api/api";
// import BillDetails from "./BillDetailsPage.vue";

export default {
    components:{
        Bottom,
        TopNavigation,
        OrderDetails,
        // LeaveWord,
        // BillDetails, // 账单明细
    },
    data() {
        return {
            activeName: 'first',
            // 账单变动弹窗打开状态
            dialogTableVisible:false,
            canshu:{},
            headers:{
                token: localStorage.getItem('token')
            },
            totalMoney:0,
            // 文件列表
            fileList:[],
            parentMessage:{
                order_id:'', // --订单id
                pol_id:'', // --起运港id
                pod_id:'', // --目的港id
                etd:'', // --计划离港日期
                eta:'', // --计划到港日期
                shipping_date:'', // --船期，离港日期至到岗日期天数
                cutoff_bill_of_lading_time:'', // --截单时间
                cutoff_enter_the_port_time:'', // --截港时间
            },
            bill_change:{
                surcharge:[]
            },
            // 是否显示未读留言
            hiddenBadge:true,
        }
    },
    methods: {
        handleClick() {
            if(this.activeName == 'second'){
                this.hiddenBadge=true
            }
        },
        async getDetails(){
            this.totalMoney = 0
            try {
                const res = await shipOrderDetail({
                    order_id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.bill_change.surcharge=res.data.surcharge
                    this.fileList = res.data.files

                    if(res.data.user_liuyan_num>0){
                        this.hiddenBadge = false
                    }else{
                        this.hiddenBadge = true
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
    },
    mounted(){
        this.canshu = this.$route.params
        if(this.canshu.id){
            sessionStorage.setItem('itemId',this.canshu.id)
        }
        this.getDetails()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}


.detail-content{
    background: #fff;
    margin-bottom: 92px;
    .el-tabs{
        padding: 10px 32px;
    }

    ::v-deep .el-tabs__item.is-active {
        color: #0073F5;//选中
    }
    
    ::v-deep .el-tabs__item:hover {
        color: #0073F5;//hover
        // cursor: pointer;
    }
    // 普通字体颜色
    ::v-deep .el-tabs__item {
        color: #606260;//悬浮
        // cursor: pointer;
        font-size: 18px;
    }

    // 下划线颜色
    ::v-deep .el-tabs__active-bar {
        background-color: #0073F5;
    }
    

    .san{
        .tit{
            font-size: 18px;

            margin-top: 24px;
            margin-bottom: 18px;
        }
    }

    .xiaoji{
        text-align: right;
        margin-top: 18px;
    }

    .zongji{
        height: 80px;
        background: #fff;
        border-top: 1px solid#eee;

        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-top: 32px;
        .left{
            margin-left: 32px;
            .yugu{
                display: flex;
                align-items: center;

                color: #999;
                font-size: 14px;

                margin-top: 8px;
                
            }
            span{
                color: #FE3300;
            }
        }

        .right{
            margin-right: 32px;

            .el-button{
                width: 100px;
                height: 40px;
                border-radius: 8px 8px 8px 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                font-style: normal;
                text-transform: none;
                border: 0;
            }
            .yulan{
                color: #0073F5;
            }
            .daochu{
                color: #0073F5;
                border: 1px solid #0073F5;
                margin-left: 16px;
            }
            .biandong{
                background: #0073F5;
                border-radius: 8px 8px 8px 8px;
                color: #fff;
                margin-left: 16px;
            }
        }
    }
}


.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-top: 4px;

    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
    }
    .first{
        padding-left: 24px;
        // width: 320px;
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        .queren{
            color: #0073F5;
            font-size: 14px;
            margin: 0;
        }

        .bohui{
            color: #FE3300;
            font-size: 14px;
            margin: 0;
        }

        .xie{
            color: #999;
        }
    }
    
}
</style>